<template>
  <div>
    <v-expansion-panels class="px-3 py-3" v-model="panel">
      <v-expansion-panel class="ma-0">
        <v-expansion-panel-header
          class="pa-2"
          style="background-color: #E0E0E0;"
        >
          <v-toolbar-title class="subtitle-1 font-weight-bold">
            <v-list-item class="mx-0 pa-0">
              <v-list-item-avatar class="ma-1">
                <v-icon>mdi-text-box-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="my-0 py-1">
                <v-list-item-title>
                  FORMULÁRIO DE PESQUISA DE BOLETINS
                </v-list-item-title>
                <v-list-item-subtitle class="caption">
                  {{ textForm }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat class="mx-auto pb-0 mb-0">
            <v-card-text class="pa-0 pt-4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.termo"
                    outlined
                    label="Pesquisa em Todos os campos"
                    append-icon="mdi-magnify"
                    dense
                    @keyup="verificarEnter"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                  <v-autocomplete
                    v-model="form.classificacao_tematica"
                    outlined
                    label="Publicação"
                    :items="classificacoesTematicas"
                    item-text="key"
                    item-value="key"
                    dense
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col
                  :cols="isMobile ? 12 : 2"
                  :class="isMobile ? '' : 'mr-2'"
                >
                  <v-text-field
                    v-model="form.ano"
                    outlined
                    label="Ano"
                    dense
                    v-mask="'####'"
                    @keyup="verificarEnter"
                  ></v-text-field>
                </v-col>
                <v-col :cols="isMobile ? '' : 'auto'">
                  <v-btn block color="primary" @click="buscar">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    buscar
                  </v-btn>
                </v-col>
                <v-col :cols="isMobile ? '' : 'auto'">
                  <v-btn block color="orange" dark @click="limpar" class="mx-1">
                    limpar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="px-0">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                small
                dark
                text
                @click="listarBoletinsJurisprudencia"
              >
                <v-icon class="mx-1">mdi-checkbox-marked-outline</v-icon>
                Acessar todos os boletins de jurisprudência
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-model="dialog"
      width="640"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar dark color="primary lighten-1" tile>
          <v-toolbar-title>
            BOLETINS DE JURISPRUDÊNCIA
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="boletim in boletinsJurisprudencia"
              :key="boletim.titulo"
            >
              <v-list-item-content>
                <v-list-item-title>{{ boletim.titulo }}</v-list-item-title>
                <v-list-item-subtitle
                  >Publicado em
                  {{
                    new Date(boletim.dataPublicacao).toLocaleDateString("pt-BR")
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn
                      color="primary"
                      small
                      fab
                      v-on="on"
                      @click="pesquisaBoletimSelecionado(boletim.titulo)"
                    >
                      {{ boletim.doc_count }}
                    </v-btn>
                  </template>
                  <span>Pesquisar Decisões deste Boletim</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-action>
                <show-pdf-boletim
                  @click.native.stop
                  iconButton="true"
                  icon="mdi-eye"
                  :idarqcas="boletim.idarqcas"
                  :textButton="`Acessar Boletim`"
                  :textTitle="`${boletim.titulo}`"
                >
                </show-pdf-boletim>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import ShowPdfBoletim from "@/shared/ShowPdfBoletim.vue";
export default {
  props: {
    filtrosFormulario: {},
    panelForm: { type: Number },
    isMobile: { type: Boolean, default: false }
  },
  components: {
    ShowPdfBoletim
  },
  data() {
    return {
      dialog: false,
      form: {
        // relevancia: ""
      },
      textForm: "Clique para ocultar o formulário de pesquisa",
      panel: 0,
      classificacoesTematicas: [],
      boletinsJurisprudencia: []
    };
  },
  mounted() {
    this.form = this.filtrosFormulario;
    this.getAggregations();
  },
  watch: {
    filtrosFormulario: {
      handler() {
        this.form = this.filtrosFormulario;
        // this.panel = 1;
      }
    },
    panel: {
      handler() {
        if (this.panel == 0) {
          this.textForm = "Clique para ocultar o formulário de pesquisa";
        } else {
          this.textForm =
            "Clique para expandir o formulário de pesquisa e realizar uma nova pesquisa";
        }
        this.$emit("expandirPanel", this.panel);
      }
    }
  },
  methods: {
    listarBoletinsJurisprudencia() {
      this.dialog = true;
      this.getAggregations();
    },
    verificarEnter(event) {
      if (event.keyCode === 13) {
        this.buscar();
      }
    },
    pesquisaBoletimSelecionado(boletim) {
      this.form.termo = `"${boletim}"`;
      this.dialog = false;
      this.buscar();
    },
    getAggregations() {
      Vue.axios({
        method: "get",
        url: process.env.VUE_APP_URL + "/boletim/tipos",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(responseTipos => {
        this.classificacoesTematicas =
          responseTipos.data.data.aggregations.ClassificacaoTematica.buckets;
        this.boletinsJurisprudencia = responseTipos.data.data.aggregations.BoletimTitulo.buckets.map(
          bucket => ({
            titulo: bucket.key,
            doc_count: bucket.doc_count,
            dataPublicacao:
              bucket.DataPublicacao.buckets.length > 0
                ? bucket.DataPublicacao.buckets[0].key
                : "Sem Data de Publicação",
            idarqcas:
              bucket.idarqcas.buckets.length > 0
                ? bucket.idarqcas.buckets[0].key
                : "Sem idarqcas"
          })
        );
      });
    },
    buscar() {
      // console.log(this.form);
      this.panel = 1;
      this.form.hash = "";
      this.form.historico = false;
      this.form.selected = 0;
      this.form.isMobile = this.isMobile;
      this.$emit("search", this.form);
    },
    limpar() {
      this.form = {};
    }
  }
};
</script>
